import { render, staticRenderFns } from "./RecL_List.vue?vue&type=template&id=279e5692"
import script from "./RecL_List.vue?vue&type=script&lang=js"
export * from "./RecL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports